export default __webpack_public_path__ + "static/media/G5PS_150.fcd7de85.jpg";